import { Typography, Box } from '@mui/material'
import { type Log } from 'src/types'
import { capitalizeFirst } from 'src/utils/stringUtils'

interface LogProps {
  log?: Log
}

const container = {
  width: '100%',
  maxWidth: '400px',
  opacity: '0.7'
}

const LogEntry = ({ log }: LogProps) => (
  <Box sx={container}>
    { log ? (
        <Typography variant="body2" fontSize='0.875rem'>
          <span style={{
            color: log.omen === 'good'
              ? 'lightgreen'
              : log.omen === 'bad'
                ? 'crimson'
                : log.omen === 'special'
                  ? 'gold'
                  : 'white'
          }}>
            {log.author && log.author.length > 0 ? `${capitalizeFirst(log.author)}: ` : ''}
            {log.text}
          </span>
        </Typography>
    ) : null}

    { log && log.cue ? (
      <Typography color="white" fontStyle="italic" fontSize="14px">{`- ${log.cue}`}</Typography>
    ) : null }
  </Box>
)

export default LogEntry
